import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanLoginActivate } from 'src/app/core/_guards/auth.guard';
import { RouteConstant } from '../../../../../src/app/core/_constants/route.constant';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { PasswordUpdatedComponent } from './password-updated/password-updated.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

const routes: Routes = [
  {
    path: `${RouteConstant.Login}`,
    component: LoginComponent,
    canActivate: [CanLoginActivate]
  },
  {
    path: '',
    component: LoginComponent,
    canActivate: [CanLoginActivate]
  },
  {
    path: `${RouteConstant.ForgotPassword}`,
    component: ForgotPasswordComponent,
    canActivate: [CanLoginActivate]
  },
  {
    path: `${RouteConstant.ResetPassword}`,
    component: ResetPasswordComponent,
    canActivate: [CanLoginActivate]
  },
  {
    path: `${RouteConstant.PasswordUpdated}`,
    component: PasswordUpdatedComponent,
    canActivate: [CanLoginActivate]
  },
  {
    path: `${RouteConstant.VerifyEmail}/:encryptStr`,
    component: VerifyEmailComponent,
    canActivate: [CanLoginActivate]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
